import { motion } from "framer-motion";
import { IMG } from "@/components/data";
import { useLang } from "@/i18n";
import { Check, X } from "lucide-react";

export default function GruppiAcquisto() {
  const { t } = useLang();
  const go = () => document.querySelector("#preventivo")?.scrollIntoView({ behavior: "smooth" });
  return (
    <section id="gruppi" className="pt-[25px] pb-20 md:pt-[41px] md:pb-28 bg-white">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 border border-ink/80 rounded-2xl overflow-hidden">
          <div className="relative min-h-[320px] lg:min-h-[520px] overflow-hidden border-b lg:border-b-0 lg:border-r border-ink/80">
            <img src={IMG.warehouse} alt="Logistica magazzino" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-ink/30" />
            <div className="absolute top-0 left-0 right-0 bg-ferrari grain text-white px-5 py-4 flex items-center justify-center">
              <span className="font-display font-bold uppercase tracking-tight text-lg">{t.gruppi.badge}</span>
            </div>
          </div>

          <div className="p-8 md:p-14 flex flex-col justify-center">
            <span className="text-xs font-bold uppercase tracking-[0.25em] text-ferrari">{t.gruppi.label}</span>
            <h2 className="font-display font-extrabold uppercase tracking-tighter text-4xl md:text-5xl mt-4 leading-[0.9]">
              {t.gruppi.titleA}<br />{t.gruppi.titleB}
            </h2>
            <p className="mt-5 text-ink/65 text-base md:text-lg leading-relaxed max-w-lg">{t.gruppi.desc}</p>

            <div className="mt-8 space-y-3">
              <motion.div
                initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.5 }}
                className="flex items-center gap-3 border border-ink/80 px-4 py-3 rounded-xl"
              >
                <span className="w-7 h-7 bg-ferrari text-white flex items-center justify-center shrink-0"><Check size={16} /></span>
                <span className="font-semibold text-sm md:text-base">{t.gruppi.yes}</span>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
                className="flex items-center gap-3 border border-ink/30 px-4 py-3 text-ink/50 rounded-xl"
              >
                <span className="w-7 h-7 bg-ink/15 text-ink flex items-center justify-center shrink-0"><X size={16} /></span>
                <span className="font-semibold text-sm md:text-base line-through decoration-ferrari/60">{t.gruppi.no}</span>
              </motion.div>
            </div>

            <button
              data-testid="gruppi-quote-btn"
              onClick={go}
              className="mt-9 self-start bg-ink text-white font-bold uppercase tracking-[0.12em] text-sm px-8 py-4 hover:bg-ferrari transition-colors duration-200"
            >
              {t.gruppi.cta}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
